export default {
  add_user: "Cadastrar perfil",
  list_profiles: "Lista de perfis",
  list_permissions: "Lista de permissões",
  update_user: "Atualizar perfil",
  update_profile: "Editar perfil",
  change_permissions: "Alterar permissões",
  actions: "Ações",
  profile: "Perfil",
  permissions_assigned: "Permissões atribuídas",
  permissions_available: "Permissões disponíveis",
  search_by_name: "Pesquisar por nome",
  remove_all: "Remover todos",
  select_all: "Selecionar todos",
  remove: "Remover",
  permission: "Permissão",
  slug: "Slug",
  add: "Adicionar",
};
